export default __webpack_public_path__ + "static/media/email.9828880d.svg";